import { MapUiTheme } from '../../common';

export const tooltipTheme = {
  defaultStyles: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.white,
    fontSize: (theme: MapUiTheme) => theme.fontSize.sm,
  },
  container: {
    position: 'absolute',
    display: 'flex',
    zIndex: (theme: MapUiTheme) => theme.zIndices.tooltip,
    justifyContent: 'center',
    alignItems: 'center',
  },
  shadowContainer: {
    zIndex: (theme: MapUiTheme) => theme.zIndices.auto,
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderRadius: '5px',
  },
  textbox: {
    position: 'relative',
    borderRadius: '5px',
    overflow: 'hidden',
    color: 'inherit',
  },
  arrow: {
    transform: 'rotate(45deg)',
    width: '15px',
    height: '15px',
    margin: '3px',
    zIndex: 1,
    borderBottom: 'none',
    borderRight: 'none',
  },
  side: {
    top: { justifyContent: 'center', width: '100%', bottom: '100%' },
    bottom: { justifyContent: 'center', width: '100%' },
    left: { justifyContent: 'flex-end' },
    right: { justifyContent: 'flex-start' },
  },
};
